<template>
    <div>
        <el-table
            :data="communities"
            @sort-change="onSortChange"
            row-key="id"
            v-loading="loading"
            ref="table"
        >
            <el-table-column label="Name" prop="name" sortable="custom" />
            <el-table-column
                label="City and State"
                prop="state"
                sortable="custom"
            >
                <template slot-scope="{ row }" v-if="row.address">
                    {{ row.address.city }}, {{ row.address.state }}
                </template>
            </el-table-column>
            <el-table-column label="Logo" prop="formatted_logo">
                <template slot-scope="scope">
                    <img
                        :src="scope.row.formatted_logo.url"
                        v-if="scope.row.formatted_logo"
                        width="100"
                    />
                </template>
            </el-table-column>
            <el-table-column
                label="Suspended"
                prop="suspended"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <el-button-group>
                        <el-switch
                            :value="scope.row.suspended"
                            @change="changeSuspensionStatus(scope.row)"
                        >
                        </el-switch>
                    </el-button-group>
                </template>
            </el-table-column>
            <el-table-column
                label="Current Issue"
                prop="current_issue"
                sortable="custom"
            >
                <template slot-scope="{ row }">
                    {{ currentIssueDate(row.current_issue) }}
                </template>
            </el-table-column>
            <el-table-column prop="actions" width="260px">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button
                            @click="editItem(scope.row)"
                            icon="mdi mdi-pencil"
                            size="small"
                            v-if="canEditCommunity"
                            >Edit</el-button
                        >
                        <el-button
                            @click="login(scope.row)"
                            icon="mdi mdi-login"
                            size="small"
                            class="el-button--corwin-green"
                            >Login</el-button
                        >
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>

        <app-pagination
            :pagination="pagination"
            @current-change="onCurrentPageChange"
            class="mt-10"
        />
    </div>
</template>

<script>
export default {
    props: {
        communities: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        pagination: {
            type: Object,
            required: true
        },
        canEditCommunity: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onSortChange(sort) {
            this.$emit("sort-change", sort);
        },
        changeSuspensionStatus(row) {
            this.$emit("change-suspension-status", row);
        },
        currentIssueDate(date) {
            if (date == null) {
                return "(no order)";
            } else {
                return moment(date).format("MMMM YYYY");
            }
        },
        editItem(row) {
            this.$emit("edit-item", row);
        },
        login(row) {
            this.$emit("login", row);
        },
        onCurrentPageChange(page) {
            this.$emit("current-change", page);
        }
    }
};
</script>
